module.exports = {"130728100":"柴沟堡镇","130728101":"左卫镇","130728102":"头百户镇","130728103":"怀安城镇","130728200":"渡口堡乡","130728201":"第六屯乡","130728202":"西湾堡乡","130728203":"西沙城乡","130728204":"太平庄乡","130728205":"王虎屯乡","130728206":"第三堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130728.json
// module id = 278
// module chunks = 0